module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "calc(100% - 220px)"
    }
  }, [_c('v-layout', {
    staticClass: "blue-grey lighten-5",
    attrs: {
      "id": "pc-sort-box",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2 search",
    attrs: {
      "xs5": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm7": ""
    }
  }, [_c('organization-pc-add-btn', {
    ref: "organizationAdd",
    on: {
      "reload": _vm.getOrganizationPcs
    }
  })], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "id": "pc-list-main",
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "white",
    attrs: {
      "xs12": "",
      "sm5": "",
      "id": "pc-list"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.filteredPcs,
      "select-all": "",
      "disable-initial-sort": "",
      "hide-headers": "",
      "item-key": "locationId"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              _vm.selectOrganization(props.item)
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left body-1"
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right caption grey--text text--darken-2"
        }, [_vm._v("\n                " + _vm._s(props.item.created) + "\n            ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "grey lighten-3",
    attrs: {
      "xs12": "",
      "sm7": "",
      "id": "pc-detail"
    }
  }, [_c('v-card', {
    staticClass: "ma-2 pl-3"
  }, [_c('div', {
    staticClass: "setting"
  }, [_c('v-menu', {
    attrs: {
      "left": "",
      "offset-y": "",
      "disabled": _vm.settingBtnDisabled
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "caption grey--text"
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.editOrganization()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('btn.edit')) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "align-baseline pa-0"
  }, [_c('h2', {
    attrs: {
      "id": "pc-name"
    }
  }, [_vm._v(_vm._s(_vm.pc.name))]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.pc.description))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.incharge')))]), _vm._v("\n                " + _vm._s(_vm.pc.contact) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.tel')))]), _vm._v("\n                " + _vm._s(_vm.pc.phone) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('account.email')))]), _vm._v("\n                " + _vm._s(_vm.pc.email) + "\n              ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "pc-info pl-2",
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('aplix-use-only.customer-category')))]), _vm._v("\n                " + _vm._s(_vm.pc.customerCategoryName) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 account-list",
    attrs: {
      "headers": _vm.listHeaders,
      "items": _vm.accountList,
      "item-key": "username"
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', [(props.item.user_status === 2) ? _c('div', [_c('v-menu', {
          attrs: {
            "left": "",
            "offset-y": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("build")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
          on: {
            "click": function($event) {
              _vm.resendMail(props.item.id)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$t('btn.resend')) + "\n                      ")])], 1)], 1)], 1) : _vm._e()])])]
      }
    }])
  })], 1), _vm._v(" "), _c('organization-edit-btn', {
    ref: "organizationEditDialog",
    on: {
      "child-action": _vm.getOrganizationPcs
    }
  })], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "absolute": "",
      "top": "",
      "right": "",
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.snackbarMessage) + "\n  ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-40611178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountOrganizationPcList.vue
// module id = 1924
// module chunks = 0